import { Icons } from '@commenda/kakashi';
import { classNames } from '@commenda/utils';

interface FilterValueProps {
  label: string;
  onRemove: () => void;
  disabled?: boolean;
}

export const FilterValue = ({
  label,
  onRemove,
  disabled = false,
}: FilterValueProps) => {
  if (!label) return null;
  return (
    <div
      className={classNames(
        'inline-flex items-center gap-2 h-10 bg-bg-tertiary rounded-md whitespace-nowrap border border-border-primary',
        disabled && 'cursor-not-allowed'
      )}
    >
      <span className="txt-small-medium text-fg-primary truncate px-2">
        {label}
      </span>
      <button
        type="button"
        onClick={onRemove}
        disabled={disabled}
        className="text-fg-quaternary hover:text-fg-quaternary-hover bg-white cursor-pointer border-l border-border-primary min-w-10 h-full flex items-center justify-center overflow-hidden rounded-r-md disabled:cursor-not-allowed"
      >
        <Icons.XClose className="size-4" />
      </button>
    </div>
  );
};
